
import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-slate-900 shadow-lg' : 'bg-slate-900/98'}`}>
      <nav className="container mx-auto px-6 py-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <h1 className="text-2xl font-bold text-white tracking-wider" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              株式会社eta
            </h1>
          </div>

          <div className="flex items-center gap-10">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-300 hover:text-amber-400 font-medium transition-colors duration-300 tracking-wide"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              会社概要
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-300 hover:text-amber-400 font-medium transition-colors duration-300 tracking-wide"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              事業内容
            </button>
            <button 
              onClick={() => scrollToSection('plan')}
              className="text-gray-300 hover:text-amber-400 font-medium transition-colors duration-300 tracking-wide"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              事業計画
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-7 py-2.5 bg-amber-500 text-slate-900 font-bold hover:bg-amber-400 transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-amber-500/50"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              お問い合わせ
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}
